import { Component } from '@angular/core';
import { UilabMatChipsModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface ChipExample {
    readonly variant: 'filled' | 'outlined';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly previewLabel: string;
    readonly outlined: boolean;
}

@Component({
    selector: 'avd-chip-examples',
    templateUrl: './chip-examples.component.html',
    styleUrls: ['./chip-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatChipsModule,
    ],
})
export class ChipExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/docs/components-chip--docs`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/chips`;

    readonly examples: readonly ChipExample[] = [
        {
            variant: 'outlined',
            label: 'Outlined Chip',
            description:
                'Use outlined chips for a lower-emphasis alternative style.',
            htmlSnippet: `<uilab-mat-chip>Chip</uilab-mat-chip>`,
            previewLabel: 'Chip',
            outlined: true,
        },
        {
            variant: 'filled',
            label: 'Filled Chip',
            description:
                'Use filled chips for default, higher-emphasis status and labels.',
            htmlSnippet: `<uilab-mat-chip variant="filled">Chip</uilab-mat-chip>`,
            previewLabel: 'Chip',
            outlined: false,
        },
    ];
}
